import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/node_modules/@mui/material/Autocomplete/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/node_modules/@mui/material/Checkbox/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/node_modules/@mui/material/Divider/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/node_modules/@mui/material/MenuItem/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/auth/context/jwt/action.ts");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/auth/context/jwt/auth-provider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/auth/context/jwt/utils.ts");
;
import(/* webpackMode: "eager", webpackExports: ["MotionLazy"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/animate/motion-lazy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/app-auto-update/app-auto-update.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HelmetProvider"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/helmet-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewRelicBrowserProvider"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/new-relic/new-relic-browser-provider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/progress-bar/progress-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/service-worker-registration.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/settings/context/settings-provider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/settings/context/use-settings-context.ts");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/settings/drawer/settings-drawer.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/components/snackbar/snackbar.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/global.css");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/locales/all-langs.ts");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/locales/i18n-provider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/locales/localization-provider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/locales/use-i18n-reload.ts");
;
import(/* webpackMode: "eager" */ "/tmp/l8-dashboard-v2.2.2/frontend/src/locales/use-locales.ts");
;
import(/* webpackMode: "eager", webpackExports: ["CheckoutProvider"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/sections/checkout/context/checkout-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useCheckoutContext"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/sections/checkout/context/use-checkout-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getInitColorSchemeScript"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/theme/color-scheme-script.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/tmp/l8-dashboard-v2.2.2/frontend/src/theme/theme-provider.tsx");
